import type { PopupData } from 'webapp-types';

import CommonFullscreenLoaderComponent from 'webapp/components/common/fullscreen-loader';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class NavigationModalFullscreenLoaderComponent extends PopupInnerModalComponent<PopupData.Common.FullscreenLoader> {
	get text() {
		return this.popupData.text || '';
	}
	<template>
		<CommonFullscreenLoaderComponent>
			{{#if this.text}}
				<p>{{this.text}}</p>
			{{/if}}
		</CommonFullscreenLoaderComponent>
	</template>
}
